import { Component } from '@angular/core';

@Component({
  selector: 'spl-ui-tagline',
  imports: [],
  templateUrl: './tagline.html',
  styleUrl: './tagline.scss',
})
export class SplUiTagline {}
